import { useEffect } from "react";

import {
  useGetCurrentAccountIfLiveElseTradingAccount,
  useGetOwnerDetails,
  useRequest,
} from "./v2/api/hooks";
import { queryKeys } from "./v2/api/queryKeys";
import {
  type Account,
  getIntercomUserHash,
  type OwnerDetails,
} from "./v2/api/rest/account";

const bootIntercom = (
  account: Account,
  details: OwnerDetails,
  userHash: string,
) => {
  window.Intercom("boot", {
    app_id: "p7a9jdob",
    user_id: details.owner_id,
    id: details.owner_id,
    email: account.email,
    name: account.name,
    firstName: details.given_name,
    lastName: details.family_name,
    status: account.status,
    createdAt: account.created_at,
    created_at: account.created_at,
    portfolioValue: account.equity,
    country: details.country_of_tax_residence,
    state: details.state,
    clearing_broker: account.clearing_broker,
    user_hash: userHash,
  });
};

export const Intercom = () => {
  const { account } = useGetCurrentAccountIfLiveElseTradingAccount();
  const { details } = useGetOwnerDetails();
  const ownerID = details?.owner_id ?? "";

  const { data: userHash, error: userHashError } = useRequest(
    queryKeys.accounts.intercomHash(ownerID),
    () => getIntercomUserHash(),
    {
      enabled: !!ownerID,
      staleTime: Infinity,
      gcTime: 9999999,
      refetchOnWindowFocus: false,
      // Log-only; suppress the shared error toast for this background query.
      meta: { showErrorToast: false },
    },
  );

  useEffect(() => {
    if (userHashError) {
      console.error("Intercom Error", userHashError);
    }
  }, [userHashError]);

  useEffect(() => {
    if (details && account && userHash) {
      bootIntercom(account, details, userHash);
    }
  }, [account, details, userHash]);

  return null;
};
